import moduleName from '../moduleName';

export default {
  SITES_UPDATED: `${moduleName}/SITES_UPDATED`,
  SITE_UPDATED: `${moduleName}/SITE_UPDATED`,
};
